import React from 'react';
import DisabledCommentIcon from '@wix/da-ds/pkg/Icons/DisabledComment';
import classnames from 'classnames';
import s from './DisabledComment.scss';
var DisabledComment = function (_a) {
    var className = _a.className, title = _a.title;
    return (React.createElement("div", { className: classnames(s['comments-disabled'], className) },
        React.createElement(DisabledCommentIcon, null),
        React.createElement("span", { className: s['comments-disabled-text'] }, title)));
};
DisabledComment.displayName = 'DisabledComment';
export default DisabledComment;
//# sourceMappingURL=DisabledComment.js.map